// Utilidad para manejo de encriptación/codificación
export const encodePassword = (password: string): string => {
  return btoa(password);
};

export const decodePassword = (encoded: string): string => {
  return atob(encoded);
};